export enum I18nLocaleEnum {
  EN = "en",
  AR = "ar",
}
